import { render } from "./OpenView.vue?vue&type=template&id=cf3023bc&scoped=true&ts=true"
import script from "./OpenView.vue?vue&type=script&lang=ts"
export * from "./OpenView.vue?vue&type=script&lang=ts"

import "./OpenView.vue?vue&type=style&index=0&id=cf3023bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf3023bc"]])

export default __exports__